<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!request">
      <span class="loader"></span>
    </span>
    <div v-if="request" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        :value="currentTab"
        @onTabChanged="tabChanged"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96" />
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <request-view-global
            :request="request"
            @requestUpdated="requestUpdated"
          />
        </tab-pane>

        <tab-pane title="gallery" id="2">
          <span slot="title">
            <i class="fa fa-image" />
            {{ $t("COMMON.PICTURES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <request-view-gallery :request="request" />
          </div>
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
        >
          <span slot="title">
            <i class="ni ni-folder-17" />
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="request" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file" />
            {{ $t("COMMON.LOGS") }}
          </span>
          <request-view-logs :request="request" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import RequestViewLogs from "../partials/RequestViewLogs.vue";
import RequestViewGlobal from "../partials/RequestViewGlobal.vue";
import RequestViewGallery from "../partials/RequestViewGallery.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    RequestViewGlobal,
    RequestViewLogs,
    ListFileComponent,
    RequestViewGallery,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    requestId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      request: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("requests/get", this.requestId);
        this.request = this.$store.getters["requests/request"];
        this.$emit("requestLoaded", this.request);
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    requestUpdated() {
      this.$emit("requestUpdated", true);
    },
  },
};
</script>
